import React, { Component } from "react";
import { connect } from "react-redux";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import "../../customize.scss";

export class TermConditionEditor extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            index: props.data.index,
            description: props.data.description,
            originalText: props.data.originalText,
            mounted: false // <-- initially not mounted
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.editorWrapperRef = React.createRef();
        this.originalRef = React.createRef();
        this.editorRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ mounted: true });
        document.addEventListener("mousedown", this.handleDocumentClick);
        document.addEventListener("touchstart", this.handleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleDocumentClick);
        document.removeEventListener("touchstart", this.handleDocumentClick);
    }

    handleDocumentClick = (e) => {
        // If click target is outside the editor container, treat it as blur
        if (this.editorWrapperRef.current && !this.editorWrapperRef.current.contains(e.target)) {
            // console.log('🟠 Clicked outside editor → trigger blur manually');

            if(this.originalRef.current && this.editorRef.current) {
                const originalDescriptionHtml = this.originalRef.current.getEditor()?.root?.innerHTML;
                const changedDescriptionHtml = this.editorRef.current.getEditor()?.root?.innerHTML;

                const isChanged = (originalDescriptionHtml !== changedDescriptionHtml);

                this.props.events?.onChangeTerms?.(changedDescriptionHtml, isChanged, this.state.index);
            }
        }
    };

    handleChange = (content, delta, source, editor) => {
        let { description } = this.state;        
        description = editor.getHTML();
        this.setState({ description });
    };

    handleBlur = (previousRange, source, editor) => {
        this.props.events.onChangeTerms(editor.getHTML(), this.state.index);
    };

    render() {
        const { mounted, description, originalText } = this.state;
        if (!mounted) return null; // or return a loading placeholder

        return (
            <>
                <div ref={this.editorWrapperRef}>
                    <ReactQuill 
                        ref={this.editorRef}
                        // onBlur={this.handleBlur}
                        onChange={this.handleChange}
                        defaultValue={description}
                    />
                </div>
                <ReactQuill
                    ref={this.originalRef}
                    theme={null}
                    readOnly
                    defaultValue={originalText}
                    style={{ display: "none" }}
                />
            </>
        );
    }
}


export default TermConditionEditor;